const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '15px 20px',
    background: '#1a1a2e',
    color: '#fff',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
  },
  left: {
    display: 'flex',
    alignItems: 'center',
  },
  backButton: {
    padding: '8px 15px',
    background: '#4ecdc4',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
  },
  title: {
    fontSize: '20px',
    fontWeight: 'bold',
    marginLeft: '15px',
  },
  right: {
    display: 'flex',
    gap: '10px',
  },
}

export default function Header({ title, onBack, rightContent, noBack }) {
  return (
    <div style={styles.header}>
      <div style={styles.left}>
        {onBack && (
          <button style={styles.backButton} onClick={onBack}>
            ← Zurück
          </button>
        )}
        <span style={styles.title}>{title}</span>
      </div>
      {rightContent && <div style={styles.right}>{rightContent}</div>}
    </div>
  )
}
